import { render } from "./mizecore.vue?vue&type=template&id=1f15879e&scoped=true"
import script from "./mizecore.vue?vue&type=script&lang=js"
export * from "./mizecore.vue?vue&type=script&lang=js"

import "./mizecore.vue?vue&type=style&index=0&id=1f15879e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f15879e"]])

export default __exports__